import { render, staticRenderFns } from "./TotalsRow.vue?vue&type=template&id=19a3adeb&scoped=true&"
import script from "./TotalsRow.vue?vue&type=script&lang=js&"
export * from "./TotalsRow.vue?vue&type=script&lang=js&"
import style0 from "./TotalsRow.vue?vue&type=style&index=0&id=19a3adeb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a3adeb",
  null
  
)

export default component.exports